export default __webpack_public_path__ + "static/media/ztocks-logo.83b7dbf9.png";